import parsePhoneNumber, { isValidPhoneNumber } from "libphonenumber-js";

const INVISIBLE_CHARS_RE = /[\u200B-\u200D\u2060\uFEFF\u00AD]/g;

export const sanitizePhoneInput = (value: string) => {
  if (!value) return value;
  return value.replace(INVISIBLE_CHARS_RE, "").replace(/\u00A0/g, " ");
};

export const normalizeManualPhoneListInput = (value: string) => {
  if (!value) return value;
  return sanitizePhoneInput(value)
    .replace(/\r\n?/g, "\n")
    .replace(/,/g, "\n")
    .split("\n")
    .map(line => line.trim())
    .join("\n");
};

export const parseManualPhoneList = (value: string) => {
  return normalizeManualPhoneListInput(value)
    .split("\n")
    .map(num => num.trim())
    .filter(Boolean);
};

export const formatPhoneNumber = (number: string) => {
 if (!number) return;
 
 const cleaned = sanitizePhoneInput(number);
 if (isValidPhoneNumber(cleaned)) {
    const phoneNumber = parsePhoneNumber(cleaned);
    return phoneNumber?.formatNational();
  } else {
    return number;
  }
};

export const phoneNumberValidate = (number: string) => {
  try {
    const phoneNumber = parsePhoneNumber(sanitizePhoneInput(number), "US");
    return phoneNumber?.isValid();
  } catch (error) {
    return false;
  }
};

export function isValidShortCodeSms(phoneNumber: string) {
  const regex = /^\d{5,6}$/;

  return regex.test(sanitizePhoneInput(phoneNumber));
}

export const phoneNumberFormatE164 = (number: string) => {
  const phoneNumber: any = parsePhoneNumber(sanitizePhoneInput(number), "US");
  if (phoneNumber?.isValid()) {
    return phoneNumber.number;
  } else {
    return null;
  }
};
